import { FetchError } from '@/libs/errors'
import { envInt } from '@/libs/utils/env'

export async function fetchRetry(
  url: string,
  options: RequestInit,
  maxRetry = 3
) {
  const delayFactor = envInt('MAX_RETRY_DELAY_FACTOR', 3)
  let error
  if (url) {
    for (let i = 0; i < maxRetry; i++) {
      try {
        const delay = i === 0 ? 0 : delayFactor ** i * 1000
        const msg = await new Promise(resolve =>
          setTimeout(
            () =>
              resolve(
                `Retry ${i} to ${options.method} ${url}\ndelay=${
                  delay / 1000
                } second(s)`
              ),
            delay
          )
        )
        if (i > 0) {
          console.info(msg)
        }
        return await fetch(url, options)
      } catch (err) {
        error = err as any
        if (error.name === 'AbortError') {
          throw error
        }
      }
    }
  } else {
    error = new FetchError('Invalid url', { url, options, maxRetry })
  }
  throw error
}
